export default {
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  async beforeRouteLeave(to, from, next) {
    if (to.params.force) {
      return next();
    }

    const confirm = await this.$bvModal.msgBoxConfirm(
      [
        this.$createElement("p", {
          class: ["text-center"],
          domProps: {
            innerHTML:
              "페이지에서 나가시겠습니까?<br>작성된 내용은 저장되지 않습니다."
          }
        }),
        this.$createElement("p", {
          class: ["text-center", "mb-0"],
          domProps: {
            innerHTML:
              "Are you sure you want to leave the page?<br>Created content will not saved."
          }
        })
      ],
      {
        footerClass: ["justify-content-center"],
        centered: true
      }
    );

    next(!!confirm);
  },
  methods: {
    handleBeforeUnload(event) {
      event.returnValue = true;
    }
  }
};
